import React, { FC, useState } from 'react'

import { DecorationTitle, StandardButton } from 'src/components/atoms'
import { CornerBottomLeftIcon } from 'src/components/atoms/icons/CornerBottomLeftIcon'
import {
  ProjectDetailItem,
  ProjectCodeTooltipContent,
  ProjectStatusTooltipContent,
  ProjectStatusTxt,
} from 'src/components/molecules'
import { ProjectEmailDisplayNameTooltipContent } from 'src/components/molecules/projects/ProjectEmailDisplayNameTooltipContent'
import { ProjectEmailTooltipContent } from 'src/components/molecules/projects/ProjectEmailTooltipContent'
import { UpsertProjectBasicInformationModal } from 'src/components/organisms'

import { useAuthority, useGetProject } from 'src/hooks'
import { useGetCompassRoles } from 'src/hooks/useGetCompassRoles'
import { ProfileEntity, ProjectDetailEntity } from 'src/types'

type Props = {
  profile: ProfileEntity
  project: ProjectDetailEntity
  className?: string
}

export const ProjectBasicInfoDetail: FC<Props> = ({ profile, project, className }) => {
  const [isShowEditProjectModal, setIsShowEditProjectModal] = useState(false)

  const { compassRoles, loading: isCompassRolesLoading } = useGetCompassRoles()
  const { refetch } = useGetProject({ projectId: project.id })
  const { canUpdateProject } = useAuthority()

  return (
    <div className={className}>
      <div className="tw-full-justify">
        <DecorationTitle sizeType="l">基本情報</DecorationTitle>
        {canUpdateProject && (
          <StandardButton
            text="編集"
            buttonType="secondary"
            prependIconPath="settings/soft/line"
            onClick={() => setIsShowEditProjectModal(true)}
          />
        )}
      </div>
      <div className="tw-mt-s2 tw-grid tw-gap-r2">
        <ProjectDetailItem title="プロジェクト名称" detailText={project.name} />
        <ProjectDetailItem
          title="管理コード"
          detailText={project.code}
          tooltipContent={<ProjectCodeTooltipContent />}
        />
        <ProjectDetailItem
          title="ステータス"
          detailChildren={
            <ProjectStatusTxt status={project.status} sizeType="l" className="tw-font-bold" />
          }
          tooltipContent={<ProjectStatusTooltipContent />}
        />
        <div className="tw-grid tw-gap-s0">
          <ProjectDetailItem
            title="送信元メールアドレス"
            detailText={project.email ?? ''}
            tooltipContent={<ProjectEmailTooltipContent />}
          />
          {project.email && project.emailDisplayName && (
            <div className="tw-flex tw-gap-s0 tw-items-start">
              <CornerBottomLeftIcon className="tw-w-s-1 tw-shrink-0" />
              <ProjectDetailItem
                title="送信元名"
                detailText={project.emailDisplayName}
                tooltipContent={<ProjectEmailDisplayNameTooltipContent />}
              />
            </div>
          )}
        </div>
      </div>

      {profile && isShowEditProjectModal && !isCompassRolesLoading && (
        <UpsertProjectBasicInformationModal
          isOpen={isShowEditProjectModal}
          project={project}
          profile={profile}
          compassRoles={compassRoles}
          refetchProjectDetail={refetch}
          onClose={() => setIsShowEditProjectModal(false)}
        />
      )}
    </div>
  )
}
